<mf-page title="Nuevo usuario">
  <mf-app-user
    (close)="close()"
    (save)="save($event)" />
</mf-page>
